import Vue from "vue";
import Router from "vue-router";
import Home from "./components/Home.vue";
import Submit from "./components/Submit.vue";
import Admin from "./components/Admin.vue";
import Submission from "./components/Submission.vue";

Vue.use(Router);
export default new Router({
  hashbang: false,
  mode: "history",
  base: "/design-a-tote",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/dev",
      name: "home",
      component: Home
    },
    {
      path: "/submit",
      name: "submit",
      component: Submit
    },
    {
      path: "/admin",
      name: "admin",
      component: Admin
    },
    {
      path: "/submission/:id",
      name: "submission",
      component: Home
    }
  ]
});
